import $ from "jquery";
import Cookies from "js-cookie";

let cart = [];
let compare = [];
let sales = [];

// проверка на старый тип данных корзины, сравнения, скидок и ее удаление
const cookieCart = Cookies.get("cart") ? JSON.parse(Cookies.get("cart")) : null;
const cookieCompare = Cookies.get("compare")
    ? JSON.parse(Cookies.get("compare"))
    : null;
const cookieSales = Cookies.get("sales")
    ? JSON.parse(Cookies.get("sales"))
    : null;

if (cookieCart && !Array.isArray(cart)) {
    Cookies.remove("cart");
}

if (cookieCompare && !Array.isArray(compare)) {
    Cookies.remove("compare");
}

if (cookieSales && !Array.isArray(sales)) {
    Cookies.remove("sales");
}

// добавление в корзину
function addToCart(elem) {
    let id = $(elem).attr("data-id");

    $(elem).closest(".btns").addClass("active-count");
    $(elem).closest(".btns").find(".js-count .count__input").val("1");
    cart.push({ id: id, count: 1 });

    saveCart();
    showCart();
}

// удаления одного элемента
function removeElemCart(elem) {
    let id = $(elem).attr("data-id");

    cart = cart.filter((elem) => elem.id != id);

    saveCart();
}

// удаления всех элементов
function removeAllCart(elem) {
    cart = [];

    saveCart();
}

function incElemList(elem) {
    let id = $(elem).attr("data-id");
    const elemInCart = cart.find((elem) => elem.id == id);

    elemInCart.count += 1;

    saveCart();
    showCart();
}

function decElemList(elem) {
    let id = $(elem).attr("data-id");
    const elemInCart = cart.find((elem) => elem.id == id);

    if (elemInCart.count > 1) {
        elemInCart.count -= 1;
    } else {
        cart = cart.filter((elem) => elem.id != id);
        $(elem).closest(".btns").removeClass("active-count");
    }

    saveCart();
    showCart();
}

function incElemCart(elem) {
    let id = $(elem).attr("data-id");
    const elemInCart = cart.find((elem) => elem.id == id);

    elemInCart.count += 1;

    saveCart();
}

function decElemCart(elem) {
    let id = $(elem).attr("data-id");
    const elemInCart = cart.find((elem) => elem.id == id);

    elemInCart.count -= 1;

    saveCart();
}

// сохранение в корзину
function saveCart() {
    Cookies.set("cart", JSON.stringify(cart), 7);
}

// синхронизация порядка cookie с порядком строк в DOM
function reorderCartFromDom() {
    const cartById = {};

    cart.forEach((item) => {
        cartById[item.id] = item;
    });

    const newCart = [];

    $(".cart__table-item").each(function () {
        const id = $(this).attr("data-id");

        if (cartById[id]) {
            newCart.push(cartById[id]);
        }
    });

    if (newCart.length) {
        cart = newCart;
        saveCart();
    }
}

// переиндексация name="items[N][...]" после смены порядка строк
function reindexCartFormItems() {
    $(".cart__table-item").each(function (idx) {
        $(this)
            .find("[name^='items[']")
            .each(function () {
                const name = $(this).attr("name");
                const match = name && name.match(/^items\[\d+](\[.+\])$/);

                if (match) {
                    $(this).attr("name", `items[${idx}]${match[1]}`);
                }
            });
    });
}

// Показ счетчика корзины
function showCart() {
    const countItems = cart.length;

    if (countItems) {
        $("a.basket .label").text(countItems).show();
    } else {
        $("a.basket .label").hide();
    }

    if ($(".page-title_cart").length) {
        $(".page-title_cart h1").attr("data-count", countItems);
    }
}

// Загрузка корзины
function loadCart() {
    if (Cookies.get("cart")) {
        cart = JSON.parse(Cookies.get("cart"));
    }

    showCart();

    // отмечаем добавленные элементы
    if ($(".js-buy").length) {
        cart.forEach((elem) => {
            $(`.js-buy[data-id="${elem.id}"]`)
                .closest(".btns")
                .addClass("active-count")
                .find(".js-count .count__input")
                .val(elem.count);
        });
    }
}

// Добавление в сравнение
function addToCompare(elem) {
    let id = $(elem).attr("data-id");
    const elemInCompare = compare.find((elem) => elem.id == id);

    if (elemInCompare == undefined) {
        $(elem).addClass("active").find(".text").text("В сравнении");

        compare.push({ id: id, count: 1 });

        saveCompare();
        showCompare();
    } else {
        $(elem).removeClass("active").find(".text").text("Сравнить");

        compare = compare.filter((elem) => elem.id != id);

        saveCompare();
        showCompare();
    }
}

function removeElemCompare(elem) {
    let id = $(elem).attr("data-id");

    compare = compare.filter((elem) => elem.id != id);

    saveCompare();
}

// удаления всех элементов
function removeAllCompare(elem) {
    compare = [];

    saveCompare();
}

// сохранение в сравнение
function saveCompare() {
    Cookies.set("compare", JSON.stringify(compare), 7);
}

// Показ счетчика сравнения
function showCompare() {
    const countItems = compare.length;
    if (countItems) {
        $("a.compare .label").text(countItems).show();
    } else {
        $("a.compare .label").hide();
    }

    if ($(".page-title_compare").length) {
        $(".page-title_compare h1").attr("data-count", countItems);
    }
}

// Загрузка сравнения
function loadCompare() {
    if (Cookies.get("compare")) {
        compare = JSON.parse(Cookies.get("compare"));
    }

    showCompare();

    // отмечаем добавленные элементы
    if ($(".js-compare").length) {
        compare.forEach((elem) => {
            $(`.js-compare[data-id="${elem.id}"]`)
                .addClass("active")
                .find(".text")
                .text("В сравнении");
        });
    }
}

//убираем из числе разряды
function numberWithoutSpaces(x) {
    return x.toString().replace(/\s/g, "");
}

// добавление скидок
function addSales() {
    $(".cart__table-item").each(function () {
        let id = $(this).attr("data-id");
        let salesValue = $(this).find(".sale__input").val();
        let manualPrice = $(this).find(".manual-price__input").val();

        sales.push({
            id: id,
            sale: salesValue,
            manual: manualPrice,
        });
    });

    saveSales();
}

// сохранение скидок
function saveSales() {
    Cookies.set("sales", JSON.stringify(sales), 7);
}

// загрузка скидок
function loadSales() {
    if (Cookies.get("sales")) {
        sales = JSON.parse(Cookies.get("sales"));

        // отмечаем добавленные скидки
        sales.forEach((elem) => {
            if (elem.sale) {
                $(`.cart__table-item[data-id="${elem.id}"]`)
                    .find(".sale__input")
                    .val(elem.sale);

                $(`.cart__table-item[data-id="${elem.id}"]`)
                    .find(".manual-price__input")
                    .addClass("inactive");
            } else {
                $(`.cart__table-item[data-id="${elem.id}"]`)
                    .find(".manual-price__input")
                    .val(elem.manual);

                if (
                    numberWithoutSpaces(
                        $(`.cart__table-item[data-id="${elem.id}"]`)
                            .find(".manual-price__input")
                            .val()
                    ) !=
                    $(`.cart__table-item[data-id="${elem.id}"]`)
                        .find(".manual-price__input")
                        .attr("data-value")
                ) {
                    $(`.cart__table-item[data-id="${elem.id}"]`)
                        .find(".sale__input")
                        .addClass("inactive");
                }
            }
        });

        $(document).ready(function () {
            $(".cart__footer .calc").trigger("click");
        });
    }
}

// удаление скидок
function removeSales(elem) {
    let id = $(elem).attr("data-id");

    sales = sales.filter((elem) => elem.id != id);

    saveSales();
}

function removeAllSales() {
    sales = [];

    saveSales();
}

function debounce(callback, delay) {
    let timeout;

    return function () {
        clearTimeout(timeout);

        timeout = setTimeout(callback, delay);
    };
}

$(document).ready(function () {
    loadCart();
    loadCompare();

    $(".scroll-top").on("click", function () {
        $("body,html").animate(
            {
                scrollTop: 0,
            },
            600
        );
        return false;
    });
});

//показ кнопки Наверх
$(window).on("scroll", function () {
    if ($(this).scrollTop() > 200) {
        $(".scroll-top").fadeIn();
    } else {
        $(".scroll-top").fadeOut();
    }
});

export {
    addToCart,
    removeElemCart,
    removeAllCart,
    loadCart,
    showCart,
    incElemCart,
    decElemCart,
    addToCompare,
    removeElemCompare,
    removeAllCompare,
    loadCompare,
    showCompare,
    addSales,
    loadSales,
    removeSales,
    removeAllSales,
    debounce,
    incElemList,
    decElemList,
    reorderCartFromDom,
    reindexCartFormItems,
};
